document.addEventListener("DOMContentLoaded",()=>{

document.querySelectorAll(".uownit-hero").forEach((hero)=>{

const slides=hero.querySelectorAll(".uownit-slide");
const dots=hero.querySelectorAll(".uownit-dot");
const next=hero.querySelector(".uownit-next");
const prev=hero.querySelector(".uownit-prev");

if(!slides.length) return;

let current=0;
let timer=null;

function activate(index){

slides.forEach((slide,i)=>{

slide.classList.toggle("active",i===index);

if(dots[i]){
dots[i].classList.toggle("active",i===index);
}

});

current=index;

}

function nextSlide(){

activate((current+1)%slides.length);

}

function prevSlide(){

activate((current-1+slides.length)%slides.length);

}

function start(){

stop();

timer=setInterval(nextSlide,3500);

}

function stop(){

if(timer){
clearInterval(timer);
timer=null;
}

}

next?.addEventListener("click",()=>{

nextSlide();
start();

});

prev?.addEventListener("click",()=>{

prevSlide();
start();

});

dots.forEach((dot,index)=>{

dot.addEventListener("click",()=>{

activate(index);
start();

});

});

let startX=0;

hero.addEventListener("touchstart",(e)=>{

startX=e.changedTouches[0].clientX;

},{passive:true});

hero.addEventListener("touchend",(e)=>{

const endX=e.changedTouches[0].clientX;

if(startX-endX>60){

nextSlide();

}

if(endX-startX>60){

prevSlide();

}

start();

},{passive:true});

hero.addEventListener("mouseenter",stop);

hero.addEventListener("mouseleave",start);

activate(0);

start();

});

});

const countdown = document.getElementById("uownit-countdown");

if (countdown) {

    const endDate = new Date("{{ section.settings.countdown_end }}").getTime();

    function updateCountdown(){

        const now = Date.now();
        const distance = endDate - now;

        if(distance <= 0){
            countdown.innerHTML = "00:00:00";
            return;
        }

        const hours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        countdown.innerHTML =
            `${String(hours).padStart(2,"0")}:${String(minutes).padStart(2,"0")}:${String(seconds).padStart(2,"0")}`;

    }

    updateCountdown();

    setInterval(updateCountdown,1000);

}